import { render, staticRenderFns } from "./ShowGrMem.vue?vue&type=template&id=3bb665b4&scoped=true&"
import script from "./ShowGrMem.vue?vue&type=script&lang=js&"
export * from "./ShowGrMem.vue?vue&type=script&lang=js&"
import style0 from "./ShowGrMem.vue?vue&type=style&index=0&id=3bb665b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb665b4",
  null
  
)

component.options.__file = "ShowGrMem.vue"
export default component.exports